import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import $ from 'jquery';
import { ApiService } from '../../services/api.service';
import { UnreadConversationsInterface } from '../../models/ia-chatbot.interface';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-ia-chat-web',
  templateUrl: './ia-chat-web.component.html',
  styleUrls: ['./ia-chat-web.component.css'],
  standalone: false
})

export class IaChatWebComponent implements OnInit {

  environment = environment;
  brand?: string;
  chatBotVisible: boolean;

  @Input()
  iaChatbotUrl: any;

  constructor(
      protected domSanitizer: DomSanitizer,
      protected apiService: ApiService,
  ) {}

  ngOnInit() {
    this.chatBotVisible = true;
    this.brand = environment.data.brand;
    this.apiService.getForIA('check/desktop/chat/access').subscribe(
        res => {
          this.iaChatbotUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.iaChatbotUrl);
          {
            $(document).ready(() => {

              setTimeout(() => {
                $('.chatbot-message').addClass('active');
              }, 3000);

              setTimeout(() => {
                $('.chatbot-message p').css({width: 'auto', opacity: 1});
              }, 3500);

              $('.close-message').click( () => {
                $('.chatbot-message').removeClass('active');
                $('.chatbot-message p').css({width: 0, opacity: 0});
              });

              $('.open-chatbot').click( () => {
                $('#chatbot-wrapper').css({display: 'block'});

                $('#chatbot-wrapper #close-desktop').css({display: 'block'});
                $('.close-chatbot').css({display: 'block'});

                $('.chatbot-message').css({display: 'none'});
                $('.chatbot-message').removeClass('active');
                $('.chatbot-message p').css({width: 0, opacity: 0});
              });

              $('.close-chatbot').click( () => {
                $('#chatbot-wrapper').css({display: 'none'});
                $('#chatbot-launcher').css({display: 'block'});

                $('.open-chatbot').css({display: 'block'});
                $('#close-chatbot-desktop').css({display: 'none'});

                $('.chatbot-message').css({display: 'grid'});
                $('.chatbot-message').removeClass('active');
                $('.chatbot-message p').css({width: 0, opacity: 0});

                $(this).css({display: 'none'});
              });
            });
          }

          // unread conversations
          this.apiService.getForIA('unseen/conversations/0/100').subscribe(
            unreadResponse => {
                const unreadMessages = unreadResponse as UnreadConversationsInterface;
                const plural = unreadMessages.totalUnseenConversations > 1 ? 's' : '';
                {
                  $(document).ready(() => {
                    if (unreadMessages.totalUnseenConversations > 0) {
                      $('#unread-number').text(unreadMessages.totalUnseenConversations);
                      $('#welcome').html(
                        'Vous avez ' +
                        '<span style="color: #545fff;">' + unreadMessages.totalUnseenConversations + '</span> ' +
                        'message' + plural + ' non lu' + plural
                      );
                    } else {
                      $('#unread-number').css({display: 'none'});
                      $('#welcome').text('Comment puis-je vous aider ?');
                    }
                  });
                }
              }
          );
        }
    );
  }
}
